export const getAllKey = (arr, name, childName,oldArr) => {
    if (!oldArr) {
      return;
    }
    const arrs = [];
    let checked = [];
    if (!arr) {
      return;
    }
    if (!name) {
      name = 'id';
    }
    if (!childName) {
      childName = 'children';
    }
    const getChild = (arr) => {
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i][name]);
        if (arr[i][childName] && arr[i][childName].length > 0) {
          getChild(arr[i].children);
        } else {
            let id = arr[i].id;
            for(let i = 0,lent = oldArr.length; i < lent; i++){
                let val = Number(oldArr[i]);
                if(val === id){
                    checked.push(id)
                }
            }
        }
      }
      return checked;
    }
    return getChild(arr);
  }


// WEBPACK FOOTER //
// ./src/assets/js/tree/tree.js